<template>
  <div class="dynamic-field-container">
    <div class="checkbox">
      <!-- Don't use p-checkbox. It looks nicer visually but vee-validate can't validate it -->
      <!-- https://github.com/baianat/vee-validate/issues/613 -->
      <input type="checkbox" style="opacity: 1"
             data-vv-validate-on="change"
             :name="fieldName"
             :data-vv-as="field.defaultValue"
             v-validate="fieldValidationRules"
             :disabled="isTaskFieldDisabled"
             v-model="proxyValue" />
      <span class="checkbox-value">{{ field.label }}</span>
      <small class="text-danger" v-show="errors.has(fieldName)" style="display:block; margin-top: 5px;">
        {{ getError(fieldName) }}
      </small>
    </div>
  </div>
</template>

<script>
  import {generateDynamicFieldValidation, canEditTaskField} from 'src/utilities/utils'

  export default {
    inject: ['$validator'],
    props: ['field', 'value', 'commit', 'task', 'disabled'],
    fieldName: 'temp',
    computed: {
      fieldValidationRules() {
        // expressions override other validation logic
        if (this.field.expression) {
          this.fieldValidation = function(str) {
            return eval(str).apply(this)
          }.call(this, this.field.expression)
        }
        return this.fieldValidation
      },
      proxyValue: {
        get() {
          return !!this.value
        },
        set(newValue) {
          this.$store.commit(this.commit, {
            key: this.field.key, value: !!newValue
          })
        }
      },
      isTaskFieldDisabled() {
        if (this.disabled) {
          return true
        }
        return !canEditTaskField(this)
      }
    },
    data() {
      return {
        fieldValidation: {},
        statusOnLoad: null
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      }
    },
    beforeMount() {
      generateDynamicFieldValidation(this)
      this.statusOnLoad = JSON.parse(JSON.stringify(this.task.status))
    }
  }
</script>

<style scoped>
  .checkbox {
    margin-bottom: 12px;
  }
  .checkbox-value {
    padding-left: 12px;
  }
</style>
